import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatTableDataSource,
  MatPaginator,
  MatDialogRef,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { EventService } from "src/_services/event.service";
import * as moment from "moment";
import { Router, ActivatedRoute } from "@angular/router";
import {
  roleTypeOperator,
  roleTypeSap,
  disableConfigData,
  SapRoles,
} from "src/_constants/roleType";
import { Location } from "@angular/common";

@Component({
  selector: "app-market-management",
  templateUrl: "./market-management.component.html",
  styleUrls: ["./market-management.component.scss"],
})
export class MarketManagementComponent implements OnInit {
  DisplayedColumns: string[] = [
    "MarketId",
    "MarketName",
    "EventName",
    "EventId",
    "Status",
    "IsSuspended",
    "Action",
  ];
  DisplayedOPColumns: string[] = [
    "MarketId",
    "MarketName",
    "EventName",
    "EventId",
    "OperatorStatus",
  ];

  marketData;
  eventsData = [];
  competitionData = new MatTableDataSource<any>();
  operatorData = new MatTableDataSource<any>();
  providers = [];
  sportsData = [];
  count: number = 0;
  ProviderId: string = "";
  OperatorId: string = "";
  title: string = "Provider Management";
  sportId: string = "all";
  selectedSport = "all";
  selectedCompetition = "all";
  selectedEvent = "all";
  selectedCompStatus = false;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  marketModalData: any;
  configData: any;
  showOperatorData: boolean = false;
  showSAPData: boolean = false;
  sapRoles = SapRoles;
  constructor(
    private appService: AppService,
    private eventService: EventService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    if (this.sapRoles.RolexAdmin === this.userRole.role) {
      this.DisplayedColumns = [
        "MarketId",
        "MarketName",
        "EventName",
        "EventId",
        "Status",
        "IsSuspended",
      ];
    }
    if (disableConfigData.includes(this.userRole.role)) {
      this.DisplayedColumns = this.DisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    this.showOperatorData =
      roleTypeOperator.includes(this.userRole.role) ||
      this.userRole.role === SapRoles.GroupAdmin;
    roleTypeSap.push(this.sapRoles.RolexAdmin);
    this.showSAPData = roleTypeSap.includes(this.userRole.role);
    this.OperatorId = this.route.snapshot.params.operator;
    this.ProviderId = this.route.snapshot.params.provider;
    this.sportId = this.route.snapshot.params.sport;

    this.onChangeSports(this.sportId);
    this.selectedEvent = this.route.snapshot.params.event;
    this.onChangeEvent(this.route.snapshot.params.event);
    // this.getOurProviders();
    // this.getOurProviders();
    if (this.userRole.role === SapRoles.GroupAdmin) {
      this.title = this.OperatorId + " / " + this.title;
    }
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getDate(date: number) {
    return moment.unix(date / 1000).format("DD MMM YYYY hh:mm A");
  }

  goBack = () => {
    this.location.back();
  };

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  onSelectedProvider = async (pid) => {
    this.ProviderId = pid;
    this.selectedSport = "all";
    this.selectedCompetition = "all";
    this.getSportData(pid);
  };
  getSportData = (pid) => {
    try {
      this.appService
        .getSportCatalogData(this.OperatorId, pid)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.sportsData = res.sports;
          }
        });
    } catch (err) {}
  };
  onChangeSports = (sid) => {
    this.sportId = sid;
    this.getOurCompetition(this.ProviderId, this.sportId);
  };
  getOurCompetition = (pid, sid) => {
    try {
      this.appService
        .getCompetitionData(this.OperatorId, pid, sid,"","")
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.competitionData = res.Competition;
            this.selectedCompetition = "all";
            // this.selectedCompStatus = res.Competition[0].status;
            // this.getOurEvent(this.ProviderId, this.sportId, res.Competition[0].CompetitionId)
          }
        });
    } catch (err) {}
  };
  onChangeCompetition = (cid) => {
    let data: any = this.competitionData;
    this.selectedCompetition = cid;
    this.selectedCompStatus = data.filter(
      (item) => item.CompetitionId === cid
    )[0].status;
    this.getOurEvent(this.ProviderId, this.sportId, cid);
  };

  onChangeEvent = (eid) => {
    this.selectedEvent = eid;
    this.getOurMarket(this.ProviderId, this.sportId, eid);
  };
  getOpenDate(date: number) {
    let d = new Date(
      moment.unix(date / 1000).format("YYYY-MM-DD HH:mm")
    ).toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
    return moment(d).format("YYYY-MM-DD HH:mm");
  }
  getOurEvent = (pid, sid, cid) => {
    try {
      this.appService
        .getEventsCatalogData(this.OperatorId, pid, sid, cid,"","")
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.eventsData =
              res.events && res.events.length
                ? res.events.filter((item) => item.Status === "ACTIVE")
                : [];
          }
        });
    } catch (err) {}
  };
  getOurMarket = (pid, sid, eid) => {
    try {
      this.appService
        .getMarketCatalogData(this.OperatorId, pid, sid, eid)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.marketData = res.markets ? res.markets : res.marketStatus;
          }
        });
    } catch (err) {}
  };

  handleChangeStatus(e, data) {
    if (e.checked) {
      this.eventService
        .unBlockMarket(
          this.OperatorId,
          data.EventId,
          data.MarketId,
          this.ProviderId,
          this.sportId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Active");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.eventService
        .blockMarket(
          this.OperatorId,
          data.EventId,
          data.MarketId,
          this.ProviderId,
          this.sportId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Blocked");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
  handleChangeSuspended(e, data) {
    if (e.checked) {
      this.eventService
        .suspendMarket(
          data.EventId,
          data.MarketId,
          this.ProviderId,
          this.sportId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Suspended");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.eventService
        .resumeMarket(
          data.EventId,
          data.MarketId,
          this.ProviderId,
          this.sportId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Resumed");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
  handleClickModal(data) {
    if (this.showSAPData) {
      try {
        this.eventService
          .getModalMarketData(
            data.EventId,
            data.MarketId,
            this.ProviderId,
            this.sportId
          )
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.marketModalData = res.marketStatus;
              this.dialog.open(UserMarketModalComponent, {
                backdropClass: "backdropBackground",
                hasBackdrop: true,
                data: this.marketModalData,
              });
            } else {
              if (res.errorDescription === "Invalid Token!") {
                sessionStorage.clear();
                this.router.navigateByUrl("/login");
              }
            }
          });
      } catch (err) {}
    }
  }

  deleteModal(data) {
    try {
      this.dialog.open(DeleteMarketModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          providerId: this.ProviderId,
          sportId: this.sportId,
          eventId: data.EventId,
          marketId: data.MarketId,
          marketName: data.MarketName
        },
      });
    } catch (err) {}
  }

  openDialog(Details: any) {
    this.dialog.open(UserMarketModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        dataInfo: Details,
      },
    });
  }

  addMarket(ele) {
    this.router.navigateByUrl(
      `/add-market/${this.marketData[0].EventId}/${this.marketData[0].EventName}`
    );
  }

  gotoEdit(ele){
    console.log(ele)
    this.appService.setMarket(ele);
    this.router.navigateByUrl(`/administration/providers/${this.OperatorId}/${this.ProviderId}/${this.sportId}/${this.appService.getCompetition().CompetitionId}/${ele.EventId}/${ele.EventName}/edit-market`)
  }
}
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./market_modal.component.html",
})
export class UserMarketModalComponent {
  displayColumns: string[] = [
    "EventId",
    "EventName",
    "MarketId",
    "MarketName",
    "OperatorId",
    "ProviderStatus",
  ];
  tabledata = [];
  groupedArray: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService,
    private appService: AppService
  ) {
    this.tabledata = data;
    this.groupData();
  }

  groupData(): void {
    const groupedData = this.tabledata.reduce((acc: any, item: any) => {
      if (item.group == "") {
        item.group = "OTHER"
      }
      const groupName = item.group;
      
      if (!acc[groupName]) {
        acc[groupName] = {
          items: [],
          isActive: true
        };
      }
      
      acc[groupName].items.push(item);
      
      if (item.ProviderStatus !== 'ACTIVE') {
        acc[groupName].isActive = false;
      }
      
      return acc;
    }, {});
    this.groupedArray = Object.keys(groupedData).map(groupName => ({
      group: groupName,
      items: groupedData[groupName].items,
      isActive: groupedData[groupName].isActive ? 'ACTIVE' : 'BLOCKED'
    }));
  }

  toggleGroupStatus(e, group) {
    const operatorIds = group.items.map(item => item.OperatorId)
    let payload = {
      eventId : this.tabledata.length > 0 ? this.tabledata[0].EventId : "",
      marketId : this.tabledata.length > 0 ? this.tabledata[0].MarketId : "",
      providerId : this.tabledata.length > 0 ? this.tabledata[0].ProviderId : "",
      sportId : this.tabledata.length > 0 ? this.tabledata[0].SportId : "",
      operators: operatorIds,
      group: group.group,
    }
    if (e.checked) {
      this.eventService
        .unBlocKOpkMarket(payload)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("OPERATORS UNBLOCKED");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.eventService
        .blockOpMarket(payload)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("OPERATORS BLOCKED");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }  
  }

  handleChangeStatus(e, data) {
    let payload = {
      eventId : this.tabledata.length > 0 ? this.tabledata[0].EventId : "",
      marketId : this.tabledata.length > 0 ? this.tabledata[0].MarketId : "",
      providerId : this.tabledata.length > 0 ? this.tabledata[0].ProviderId : "",
      sportId : this.tabledata.length > 0 ? this.tabledata[0].SportId : "",
      operators: [data.OperatorId],
      group: "",
    }
    if (e.checked) {
      this.eventService
        .unBlocKOpkMarket(
          payload
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("OPERATOR ACTIVE");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.eventService
        .blockOpMarket(
          payload
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("OPERATOR BLOCKED");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
}
UserMarketModalComponent;

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./delete-market.component.html",
  styleUrls: ["./market-management.component.scss"],
})
export class DeleteMarketModalComponent {
  DATA;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public dialogRef: MatDialogRef<DeleteMarketModalComponent>,
  ) {
    this.DATA = data;
  }

  ngOnInit() {}

  deleteMarket() {
    this.appService
      .deleteMarket({
        ...this.DATA,
      })
      .subscribe(
        (res) => {
          if(res.status === "RS_OK"){
            this.appService.openSuccessBar('Market deleted')
            this.dialogRef.close()
          }
        },
        (err) => {}
      );
  }
}
